import { SxProps, Theme } from '@mui/system';

const classes = {

  checkPosition: {
    marginLeft: '10px',
    paddingBottom: '20px',
    display: 'flex',
    flexDirection: 'row-reverse',
  },

  checkboxText: {
    textAlign: 'left',
    flex: 1,
  },
  mapButton: {
    mb: 2,
    justifyContent: 'start',
    textTransform: 'none',
    width: '97.5%',
    backgroundColor: 'secondary.main',

    '& .MuiButton-endIcon': {
      marginLeft: 'auto',
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
